"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BearWorkspaceQueryFactory = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2021 GoodData Corporation
var sdk_backend_base_1 = require("@gooddata/sdk-backend-base");
var WorkspaceConverter_1 = require("../../convertors/toBackend/WorkspaceConverter");
var api_1 = require("../../utils/api");
var workspace_1 = require("../workspace");
var BearWorkspaceQueryFactory = /** @class */ (function () {
    function BearWorkspaceQueryFactory(authCall) {
        this.authCall = authCall;
    }
    BearWorkspaceQueryFactory.prototype.forUser = function (userId) {
        return new BearWorkspaceQuery(this.authCall, userId);
    };
    BearWorkspaceQueryFactory.prototype.forCurrentUser = function () {
        return new BearWorkspaceQuery(this.authCall);
    };
    return BearWorkspaceQueryFactory;
}());
exports.BearWorkspaceQueryFactory = BearWorkspaceQueryFactory;
var BearWorkspaceQuery = /** @class */ (function () {
    function BearWorkspaceQuery(authCall, userId) {
        this.authCall = authCall;
        this.userId = userId;
        this.limit = 100;
        this.offset = 0;
        this.search = undefined;
    }
    BearWorkspaceQuery.prototype.withLimit = function (limit) {
        this.limit = limit;
        return this;
    };
    BearWorkspaceQuery.prototype.withOffset = function (offset) {
        this.offset = offset;
        return this;
    };
    BearWorkspaceQuery.prototype.withSearch = function (search) {
        this.search = search;
        return this;
    };
    BearWorkspaceQuery.prototype.query = function () {
        return this.queryWorker();
    };
    BearWorkspaceQuery.prototype.queryWorker = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, sdk_backend_base_1.ServerPaging.for(function (_a) {
                        var limit = _a.limit, offset = _a.offset;
                        return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var data, _b, items, totalCount;
                            var _this = this;
                            return tslib_1.__generator(this, function (_c) {
                                switch (_c.label) {
                                    case 0: return [4 /*yield*/, this.authCall(function (sdk, _a) {
                                            var getPrincipal = _a.getPrincipal;
                                            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                                var userId, _b;
                                                return tslib_1.__generator(this, function (_c) {
                                                    switch (_c.label) {
                                                        case 0:
                                                            _b = this.userId;
                                                            if (_b) return [3 /*break*/, 2];
                                                            return [4 /*yield*/, api_1.userLoginMd5FromAuthenticatedPrincipal(getPrincipal)];
                                                        case 1:
                                                            _b = (_c.sent());
                                                            _c.label = 2;
                                                        case 2:
                                                            userId = _b;
                                                            return [2 /*return*/, sdk.project.getProjectsWithPaging(userId, offset, limit, this.search)];
                                                    }
                                                });
                                            });
                                        })];
                                    case 1:
                                        data = _c.sent();
                                        _b = data.userProjects, items = _b.items, totalCount = _b.paging.totalCount;
                                        return [2 /*return*/, {
                                                items: items.map(function (item) {
                                                    var descriptor = WorkspaceConverter_1.convertUserProject(item);
                                                    return new workspace_1.BearWorkspace(_this.authCall, descriptor.id, descriptor);
                                                }),
                                                totalCount: totalCount,
                                            }];
                                }
                            });
                        });
                    }, this.limit, this.offset)];
            });
        });
    };
    return BearWorkspaceQuery;
}());
//# sourceMappingURL=index.js.map